<table class="details col-12">
  <thead>
    <tr>
      @if (actionColumn) {
        <th></th>
      }
      @for (header of evalKey; track header.label) {
        <th>{{ header.label }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @if (dataset && dataset.length) {
      @for (account of dataset; track account; let idx = $index) {
        @if (idx < holdingsRows) {
          <tr>
            @if (actionColumn) {
              <td>
                <button
                  type="button"
                  mat-icon-button
                  class="fs-button"
                  color="primary"
                  [matTooltip]="
                    actionColumn.tooltip + ': ' + account[actionColumn.selector]
                  "
                  [matTooltipPosition]="'above'"
                  (click)="
                    nav(
                      actionColumn.link + account[actionColumn.selector],
                      actionColumn.external
                    )
                  "
                >
                  <mat-icon>{{ actionColumn.icon }}</mat-icon>
                </button>
              </td>
            }
            @for (position of evalKey; track position.label) {
              <td>
                @if (position.key && account[position.varName] === '401k') {
                  {{ position.key['FOUR01K'] }}
                } @else if (
                  position.key && account[position.varName] === '529'
                ) {
                  {{ position.key['FIVE29'] }}
                } @else if (position.varName === 'ScoreClass') {
                  <div class="score-class-container">
                    <mat-icon
                      class="scoreclass-icon me-2 {{
                        account[position.varName]
                      }}"
                      [matTooltip]="
                        scoreToolTip
                          ? scoreToolTip + account[position.varName]
                          : account[position.varName]
                      "
                    >
                      {{ scoreClassKey[account[position.varName]] }}
                    </mat-icon>
                  </div>
                } @else if (position.key && position.varName === 'NewStatus') {
                  <span
                    [class]="
                      'scoreclass-icon status ' +
                      position.key[account[position.varName]].color
                    "
                  >
                    {{
                      position.key[account[position.varName]]?.label ||
                        position.key[account[position.varName]]
                    }}
                  </span>
                } @else if (position.key) {
                  {{ position.key[account[position.varName]] }}
                } @else if (
                  position.valueMask && position.valueMask === 'currency'
                ) {
                  {{ account[position.varName] | currency }}
                } @else if (
                  position.valueMask && position.valueMask === 'date'
                ) {
                  @if (
                    account[position.varName] &&
                    account[position.varName] !== '1900-01-01T00:00:00'
                  ) {
                    {{ account[position.varName] | date: 'shortDate' }}
                  } @else {
                    N/A
                  }
                } @else if (
                  position.valueMask && position.valueMask === 'percent'
                ) {
                  {{ account[position.varName] | percent: '1.3' }}
                } @else if (
                  position.decryptTarget && account[position.decryptTarget]
                ) {
                  <span class="decrypt-cell">
                    {{ account[position.varName] }}

                    <button
                      type="button"
                      class="ms-1 decrypt-button"
                      mat-icon-button
                      matTooltip="Click to see raw value"
                      [matTooltipShowDelay]="500"
                      (click)="
                        decryptValue(
                          account[position.decryptTarget],
                          position.label
                        )
                      "
                    >
                      <mat-icon>lock_open</mat-icon>
                    </button>
                  </span>
                } @else {
                  {{ account[position.varName] }}
                }
              </td>
            }
          </tr>
        }
      }
    } @else {
      <tr class="no-data">
        <td colspan="12" class="no-results"> No data </td>
      </tr>
    }
  </tbody>
</table>
@if (dataset && dataset.length > 5) {
  <div class="toggle-row">
    <button
      type="button"
      class="me-2 w-100"
      mat-button
      color="primary"
      (click)="toggleRows('holdingsRows', dataset.length)"
    >
      <mat-icon class="me-1">
        @if (holdingsRows === 5) {
          add
        } @else {
          remove
        }
      </mat-icon>
      @if (holdingsRows === 5) {
        Show More
      } @else {
        Show Less
      }
    </button>
  </div>
}
<ngx-loading [show]="loading" />
